import BaseApiAction from "@Actions/base-api-action";

export default class GetRewardStats extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: "rewards-getRewardStats",
      payload: {
        ...this.addFieldIfExists('reward_ids', this._payload.reward_ids),
        ...this.addFieldIfExists('challenge_id', this._payload.challenge_id),
        ...this.addFieldIfExists('indistinct', this._payload.indistinct),
      },
    });
  }
}
